import classNames from 'classnames';
import styles from './BlurredOverlay.module.css';

export type BlurredOverlayProps = {
    className?: string;
    children?: React.ReactNode;
};

export function BlurredOverlay({ className, children }: BlurredOverlayProps) {
    return <div className={classNames(styles.container, className)}>{children}</div>;
}
